module.exports = __webpack_public_path__ + "img/xk.b726c44.svg";